<template>
  <div class="game">
    <div class="team home">
      <div class="score">{{ game.homeTeam.score }}</div>
      <div class="city">
        {{ game.homeTeam.city }}
      </div>
      <div class="name">
        {{ game.homeTeam.name }}
      </div>
      <div class="timestamp">
        {{ gameFormattedDate }}
      </div>
    </div>
    <div class="team-icon home">
      <div class="icon" :style="{ backgroundColor: customColor }">
        <img :src="`/img/teams-${game.league}/${game.homeTeam.icon}`" class="icon" />
      </div>
    </div>

    <div class="divider" :style="{ borderColor: customColor }"></div>

    <div class="team-icon away">
      <div class="icon" :style="{ backgroundColor: customColor }">
        <img :src="`/img/teams-${game.league}/${game.awayTeam.icon}`" class="icon" />
      </div>
    </div>
    <div class="team away">
      <div class="score">{{ game.awayTeam.score }}</div>
      <div class="city">
        {{ game.awayTeam.city }}
      </div>
      <div class="name">
        {{ game.awayTeam.name }}
      </div>
    </div>
  </div>
</template>

<script>
  import { format } from "date-fns";

  export default {
    name: 'SportsGameResult',
    props: {
      game: { type: Object, default: () => {}, required: true },
      customColor: { type: String, default: '' }
    },
    computed: {
      gameFormattedDate () {
        if (this.game.startTime) {
          return format(new Date(this.game.startTime), 'MMMM do, yyyy')
        }
        return ''
      }
    }
  }
</script>

<style>
  .game > div {
    width: auto;
    /* background: rgba(255,255,255,0.1); */
  }
  .game .team {
    width: 590px;
  }
  .game .team-icon {
    width: 134px;
  }
  .game .divider {
    width: 1px;
    border-left: 1px solid;
    margin: 130px 0 50px 0;
  }


  .team-icon {
    padding-top: 175px;
  }
  .team-icon .icon {
    width: 134px;
    height: 134px;
    border-radius: 70px;
    color: #000;
    font-size: 12px;
  }
  .team {
    padding-top: 20px;
  }
  .team.home {
    text-align: right;
  }
  .team .score {
    font-size: 148px;
    line-height: 148px;
    font-weight: bold;
  }
  .team .name,
  .team .city {
    font-size: 78px;
    line-height: 72px;
    font-weight: bold;
  }
  .timestamp {
    position: absolute;
    left: 0;
    bottom: 0;
    text-align: left;
    font-size: 25px;
    font-weight: bold;
  }
</style>
